import axios from './axyos';

export type ChatInterlocutorDto = {
  id: string;
  displayName: string;
  email?: string;
};

export type ChatThreadDto = {
  interlocutorId: string;
  interlocutor?: ChatInterlocutorDto;
  lastMessage?: string;
  lastMessageAt?: string;
  unreadCount?: number;
};

export type ChatMessageDto = {
  id: string;
  fromUserId: string;
  toUserId: string;
  interlocutorId: string;
  isMine: boolean;
  content: string;
  createdAt: string;
  readAt?: string;
};

export type ListCurrentUserConversationsResponse = {
  data?: ChatThreadDto[];
  unreadCount?: number;
  count?: number;
  status?: number;
};

export type ListMessagesByInterlocutorResponse = {
  data?: ChatMessageDto[];
  interlocutor?: ChatInterlocutorDto;
  count?: number;
  hasMore?: boolean;
  nextCursor?: {
    before?: string;
    beforeId?: string;
  } | null;
  status?: number;
};

export const listCurrentUserConversationsApi = () =>
  axios.get<ListCurrentUserConversationsResponse>('/messages/currentUser/conversations');

export const listCurrentUserMessagesByInterlocutorApi = (
  interlocutorId: string,
  options: number | { limit?: number; before?: string; beforeId?: string } = 20
) => {
  const params = typeof options === 'number'
    ? { limit: options }
    : {
        limit: options.limit ?? 20,
        before: options.before,
        beforeId: options.beforeId,
      };
  return axios.get<ListMessagesByInterlocutorResponse>(`/messages/currentUser/conversations/${encodeURIComponent(interlocutorId)}`, {
    params,
  });
};

export const sendCurrentUserMessageApi = (payload: { toUserId: string; content: string; clientMessageId?: string }) =>
  axios.post('/messages/currentUser/send', payload);

export const markCurrentUserConversationAsReadApi = (interlocutorId: string) =>
  axios.post(`/messages/currentUser/conversations/${encodeURIComponent(interlocutorId)}/read`);

export const sendCurrentUserTypingSignalApi = (payload: { toUserId: string; isTyping: boolean }) =>
  axios.post('/messages/currentUser/typing', payload);

export const deleteCurrentUserMessageApi = (messageId: string) =>
  axios.delete(`/messages/currentUser/messages/${encodeURIComponent(messageId)}`);
